import React, { useState, useEffect } from "react";
import { Modal, Button, Card, Dropdown } from "react-bootstrap";

const SPICE_LEVELS = [
    { value: "mild",       title: "1 マイルド",     en_title: "1 MILD",       index: 1, icon: "" },
    { value: "medium",     title: "2 普通",        en_title: "2 MEDIUM",     index: 2, icon: "🌶🌶" },
    { value: "hot",        title: "3 中辛",        en_title: "3 HOT",        index: 3, icon: "🌶🌶🌶"},
    { value: "very_hot",   title: "4 大辛",        en_title: "4 VERY HOT",   index: 4, icon: "🌶🌶🌶🌶"},
    { value: "super_hot",  title: "5 激辛",        en_title: "5 SUPER HOT",  index: 5, icon: "🌶🌶🌶🌶🌶" }
];

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const SlotSelectionModal = ({ show, onHide, slot, selectedSlotFoods, ln, setSelectedSlotFoods }) => {
    const [localSelected, setLocalSelected] = useState([]);

    function getSpiceTitle(value) {
        const item = SPICE_LEVELS.find(level => level.value === value);
        return item ? (ln === 'en' ? item.en_title : item.title) + item.icon : null;
    }

    useEffect(() => {
        if (show) {
            setLocalSelected(
                selectedSlotFoods
                    ? selectedSlotFoods.map(f => ({ ...f }))
                    : []
            );
        } else {
            setLocalSelected([]);
        }
    }, [show, selectedSlotFoods]);

    if (!slot) return null;

    const imageSrc = (src) => BASE_URL + "/storage/" + src;

    const toggleFoodSelection = (food) => {
        if (slot.type === "changeable") {
            setLocalSelected([food]);
            return;
        }

        const exists = localSelected.find(f => f.id === food.id);
        if (exists) {
            setLocalSelected(localSelected.filter(f => f.id !== food.id));
        } else {
            if (slot.type === "choosable" && localSelected.length >= slot.quantity) return;
            setLocalSelected([...localSelected, food]);
        }
    };

    const handleSpiceChange = (food, value) => {
        food.spice_level = value;
        setLocalSelected([...localSelected]);
    };

    const selectionLimitReached = slot.type === "choosable" && localSelected.length >= slot.quantity;

    return (
        <Modal show={show} onHide={onHide} size="xl" centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title>
                    {slot.type === "changeable" ? (ln === 'en' ? "Change Item" : "変更") : (ln === 'en' ? "Choose Item" : "選ぶ")}
                    {slot.type === "choosable" && slot.quantity && (
                        <span style={{ marginLeft: 10 }}>
                            ({ln === 'en' ? "Select up to" : "最大選択数"} {slot.quantity})
                        </span>
                    )}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="d-flex flex-wrap justify-content-center">
                    {slot.foods.map(food => {
                        const isSelected = localSelected.find(f => f.id === food.id);
                        const isDisabled = !isSelected && selectionLimitReached;

                        if (!food.set_menu_image) return null;

                        return (
                            <Card
                                key={food.id}
                                className={`m-2 ${isSelected ? "border-primary" : ""}`}
                                style={{
                                    width: 200,
                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                    opacity: isDisabled ? 0.5 : 1
                                }}
                                onClick={() => !isDisabled && toggleFoodSelection(food)}
                            >
                                <Card.Img
                                    variant="top"
                                    src={food.set_menu_image ? imageSrc(food.set_menu_image) : "/images/default-placeholder.jpg"}
                                    height={120}
                                    style={{ objectFit: "cover" }}
                                />
                                <Card.Body className="text-center">
                                    <Card.Title style={{ fontSize: '1rem' }}>
                                        {ln === 'en' ? food.name : food.japanese_name}
                                    </Card.Title>

                                    {food.additional_price > 0 && (
                                        <Card.Text style={{ fontSize: 14, color: "#ffd700" }}>
                                            +¥{parseFloat(food.additional_price || 0).toFixed(0)}
                                        </Card.Text>
                                    )}

                                    {slot.category?.name.toLowerCase() === "curry" && (
                                        <Dropdown className="mt-1">
                                            <Dropdown.Toggle size="sm" variant="outline-secondary">
                                                {getSpiceTitle(food.spice_level) || (ln === 'en' ? "Spice" : "辛さ")}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {SPICE_LEVELS.map(level => (
                                                    <Dropdown.Item
                                                        key={level.value}
                                                        active={food.spice_level === level.value}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleSpiceChange(food, level.value);
                                                        }}
                                                    >
                                                        {ln !== 'en' ? level.title : level.en_title} {level.icon}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )}

                                    <Button
                                        size="lg"
                                        variant={isSelected ? "primary" : "secondary"}
                                        className="mt-2 w-100"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (!isDisabled) toggleFoodSelection(food);
                                        }}
                                        disabled={isDisabled}
                                    >
                                        {isSelected ? (ln === 'en' ? "Selected" : "選択済み") : (ln === 'en' ? "Select" : "選択")}
                                    </Button>
                                </Card.Body>
                            </Card>
                        );
                    })}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {ln === 'en' ? "Cancel" : "キャンセル"}
                </Button>
                <Button
                    variant="primary"
                    onClick={() => {
                        setSelectedSlotFoods(localSelected);
                        onHide();
                    }}
                    disabled={localSelected.length === 0}
                >
                    {ln === 'en' ? "Confirm" : "確定"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SlotSelectionModal;
